<template>
    <div v-if="showExport">
        <ul class="export-listing">
            <li v-for="option in exportData.options" :key="option.id" class="export-option ps-2-max ml-5 mr-5">
                <div class="d-flex flex-wrap align-items-center ps-2-max ul-dark-grey">
                    {{option.displayText}}
                    <i class="fa fa-info-circle ul-tooltip" data-toggle="tooltip" data-placement="top" v-bind:title="option.toolTipText"></i>
                    <div class="option-content-div flex-grow-1 pl-5-max">
                        <select v-model="option.selectedValue" class="form-control form-control-sm rounded-0 export-setting-entry">
                            <option v-for="(selection, index) in option.options" v-bind:key="index" v-bind:value="selection.value">{{selection.text}}</option>
                        </select>
                    </div>
                </div>
            </li>
        </ul>
        <div class="export-panel" v-show="loggedIn == false">
            <a class="btn btn-dark" href="#" v-on:click.prevent="signIn">Sign In to Download</a>
        </div>
        <div class="export-panel" v-show="loggedIn == true && inLibrary == false && v2Features == false">
            This version requires an active library to download
        </div>
        <div class="export-panel align-items-center ps-2-max ul-dark-grey" v-show="loggedIn == true && (inLibrary == true || v2Features == true)">
            <div class="d-flex flex-wrap align-items-center ps-2-max ml-5 mr-5 ul-dark-grey">
                Model Download Library
                <i class="fa fa-info-circle ul-tooltip" data-toggle="tooltip" data-placement="top" title="The Model Download Library specifies the library to import the downloaded part into"></i>
                <div class="option-content-div flex-grow-1 pl-5-max">
                    <select class="form-control form-control-sm rounded-0 mt-2 mb-2" v-model="useActive">
                        <option disabled>Select Model Download Library</option>
                        <option v-show="inLibrary" v-bind:value="true">Active Library</option>
                        <option v-show="v2Features" v-bind:value="false">Select Cloud Library</option>
                    </select>
                </div>
            </div>
            <span v-if="!v2Features && inLibrary" class="alert-warning text-center">An updated version of this plugin is now available on the Autodesk App Store Marketplace with improved library selection</span>
            <div class="d-flex justify-content-center">
                <ul class="consent-listing custom-control custom-checkbox pb-1">
                    <li v-for="consent in exportData.consents" :key="consent.id">
                        <input class="custom-control-input consentRequest" v-bind:class="[{required: consent.required}]" v-bind:aria-required="consent.required" v-bind:id="consent.name" type="checkbox" v-model="consent.checked" />
                        <label class="custom-control-label" v-bind:for="consent.name">
                            <span v-if="consent.required" class="required">*</span>
                            <span v-html="consent.content"></span>
                        </label>
                    </li>
                </ul>
            </div>
            <LicenseModal></LicenseModal>
            <div class="align-items-center ps-2-max ml-5 mr-5 ul-dark-grey">
                <a class="btn btn-dark" v-show="loggedIn == true" v-bind:disabled="disableExport" href="#" v-on:click.prevent="Queue('download', 'symbol')">Download</a>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapState, mapGetters, mapActions } from 'vuex'
    import $ from 'jquery';
    import exportApiClient from '@/services/apiServices/exportApiClient.js'
    import LicenseModal from '@/components/terms/LicenseModal.vue';

    export default {
        name: 'ExportPanel',
        components: {
            LicenseModal
        },
        data() {
            return {
                exportToken: "",
                processExport: true,
                optionValue: [],
                currentTimeout: null,
                useActive: false,
                storedActive: null,
                exportData: {
                    distributorPNs: [],
                    consents: [],
                    options: [],
                    selectedExportTokens: []
                },
                gtmData: {}
            }
        },
        props: {
            currentPartUid: {
                type: String,
                default: () => {
                    return ""
                }
            },
            initialExportOptionValues: {
                type: Array,
                default: () => {
                    return []
                }
            },
            showExport: {
                type: Boolean,
                default: () => {
                    return false
                }
            }
        },
        computed: {
            ...mapState({
                inLibrary: state => state.activeProfileValid && state.activeProfile != null,
                version: state => state.version
            }),
            ...mapGetters('oidcStore', [
                'oidcIsAuthenticated'
            ]),
            loggedIn: function () {
                return this.oidcIsAuthenticated
            },
            enableExport: function () {
                return this.oidcIsAuthenticated && (this.inLibrary && this.useActive == true || this.v2Features && this.useActive == false) ;
            },
            consented: function () {
                if (this.exportData && this.exportData.consents && this.exportData.consents.length > 0) {
                    var locl = this.exportData.consents.filter(consent => consent.required == true && consent.checked == false);
                    return locl.length == 0;
                }
                return true
            },
            disableExport: function () {
                if (this.enableExport != true || this.consented != true)
                    return true;
                else
                    return null;
            },
            v2Features: function () {
                return this.version >= 2
            }
        },
        methods: {
            ...mapActions('oidcStore', [
                'authenticateOidc'
            ]),
            signIn: function () {
                var configContent = JSON.parse(process.env.VUE_APP_OIDC_OPTIONS);
                var localOptions = {
                    extraQueryParams: {
                        "Base-Url": configContent.baseurl + this.$route.params.instance,
                        "App-Type": configContent.apptype,
                        "Custom-View": configContent.customView
                    }
                };
                this.authenticateOidc({ redirectPath: this.$route.path, options: localOptions });
            },
            //Calling queue will insert the item into the queue and run until a resolution is hit.
            Queue: async function (formatAction, systemAction) {
                if (this.enableExport) {
                    this.storedActive = this.useActive;

                    if (this.useActive) //if we are using the active library, check now that we have the right one stored
                        await this.$store.dispatch('getActiveLibrary');

                    var queueRequest = {
                        formatAction: formatAction,
                        systemAction: systemAction,
                        formatTokens: [],
                        options: [],
                        distributorPNs: [],
                        consents: []
                    };

                    //grab defined export options
                    for (var i = 0; i < this.exportData.options.length; i++) {
                        queueRequest.options.push(this.exportData.options[i].selectedValue);
                    }

                    //grab defined export formats
                    for (var j = 0; j < this.exportData.selectedExportTokens.length; j++) {
                        queueRequest.formatTokens.push(this.exportData.selectedExportTokens[j]);
                    }

                    //grab distributor parts
                    queueRequest.distributorPNs = this.exportData.distributorPNs;

                    //grab export consents
                    for (var k = 0; k < this.exportData.consents.length; k++) {
                        if (this.exportData.consents[k].checked) {
                            queueRequest.consents.push(this.exportData.consents[k].id);
                        }
                    }

                    if (this.$route.params.referer && this.$route.params.referer != null) {
                        queueRequest.refererTag = this.$route.params.referer;
                    }

                    if (this.$route.params.term && this.$route.params.term != null) {
                        queueRequest.refererTerm = this.$route.params.term;
                    }

                    this.gtmData = {};

                    exportApiClient.Insert(this.currentPartUid, queueRequest).then(response => {
                        if (response.data && response.data.success) { //part found and export queued
                            this.exportToken = response.data.exportToken;
                            this.processExport = true;

                            this.gtmData = response.data.gtmContent;
                            this.$store.dispatch('downloadStart', { exportToken: this.exportToken, useActive: this.useActive });
                            if (response.data.processed) { //export complete
                                this.$store.dispatch('gtmDownloadComplete', this.gtmData); //response.data something should be here, but is not yet
                                this.$store.dispatch('downloadComplete', this.$store.exportToken);
                                this.processExport = false;
                                this.gtmData = {};
                                return { success: true, token: this.exportToken };
                            } else { //start checking
                                return this.Check(this.exportToken);
                            }
                        }
                        else { //export failed
                            this.$store.dispatch('gtmDownloadFailure', this.gtmData)
                            this.$store.dispatch('downloadFailure')
                            this.gtmData = {};
                        }
                    }).catch((ex) => {
                        this.processExport = false;
                        this.$store.dispatch('gtmDownloadFailure', this.gtmData)
                        this.$store.dispatch('downloadFailure')
                        this.gtmData = {};
                    });
                }
            },
            //Used internally to queue and itself to poll the exportApi check end point
            Check: function (token) {
                if (this.processExport) {
                    this.currentTimeout = setTimeout((token) => {
                        exportApiClient.Check(token)
                            .then(response => {
                                if (response.data) {
                                    if (response.data.state == 2) { //export complete
                                        this.$store.dispatch('gtmDownloadComplete', this.gtmData); //response.data something should be here, but is not yet
                                        this.$store.dispatch('downloadComplete', this.$store.exportToken);
                                        this.processExport = false;
                                        this.gtmData = {};
                                    } else if (response.data.state == 3) {
                                        this.$store.dispatch('gtmDownloadFailure', this.gtmData)
                                        this.$store.dispatch('downloadFailure')
                                        this.processExport = false;
                                        this.gtmData = {};
                                    } else if (response.data.state == 4) {
                                        this.$store.dispatch('gtmDownloadFailure', this.gtmData)
                                        this.$store.dispatch('downloadFailure')
                                        this.processExport = false;
                                        this.gtmData = {};
                                    } else { //check again
                                        this.Check(token);
                                    }
                                }
                            })
                            .catch((ex) => {
                                //return error
                                this.processExport = false;
                                this.$store.dispatch('gtmDownloadFailure', this.gtmData)
                                this.$store.dispatch('downloadFailure')
                                this.gtmData = {};
                            });
                        //return error and message key?
                    }, 2000, token);
                }
            }
        },
        mounted: async function () {
            this.unsubExportPanel = this.$store.subscribe((mutation, state) => {
                switch (mutation.type) {
                    case "SELECT_PART_NUMBER":
                        this.currentPart = state.navigation.selectedPartNumber;
                        break;
                    case "LOAD_CONSENT":
                        this.exportData.consents = mutation.payload;
                        break;
                    case "LOAD_OPTIONS":
                        this.exportData.options = mutation.payload;
                        break;
                    case "LOAD_EXPORTS":
                        this.exportData.selectedExportTokens = mutation.payload;
                        break;
                    case "CANCEL_EXPORT":
                        clearTimeout(this.currentTimeout);
                        this.currentTimeout = null;
                        break;
                    case "SET_ACTIVE_LIBRARY":
                        var activeAvailable = mutation.payload.valid && mutation.payload.profile;
                        var cloudAvailable = this.v2Features;

                        if (this.storedActive == true && activeAvailable) {
                            this.useActive = true;
                        } else if (this.storedActive == false && cloudAvailable) {
                            this.useActive = false;
                        } else {
                            if (activeAvailable) {
                                this.useActive = true;
                            } else {
                                this.useActive = false;
                            }
                        }
                        break;
                }
            });

            this.$nextTick(() => {
                $('.ul-tooltip').tooltip();
            });
        },
        beforeUnmount() {
            this.unsubExportPanel();
        },
        watch: {
            'initialExportOptionValues': {
                handler: function (val) {
                    for (var i = 0; i < this.exportData.options.length; i++) {
                        if (this.exportData.options[i].selectedValue == null | this.exportData.options[i].selectedValue == '') {
                            for (var j = 0; j < this.exportData.options[i].options.length; j++) {
                                if (val.includes(this.exportData.options[i].options[j].value)) {
                                    this.exportData.options[i].selectedValue = this.exportData.options[i].options[j].value;
                                }
                            }
                        }
                    }
                },
                deep: true
            },
            'exportData.options': {
                handler: function (val) {
                    for (var i = 0; i < val.length; i++) {
                        if (val[i].selectedValue == null | val[i].selectedValue == '') {
                            for (var j = 0; j < val[i].options.length; j++) {
                                if (this.initialExportOptionValues.includes(val[i].options[j].value)) {
                                    val[i].selectedValue = val[i].options[j].value;
                                }
                            }
                        }
                    }

                    this.$nextTick(() => {
                        $('.ul-tooltip').tooltip();
                    });
                },
                deep: true
            }
        }
    }
</script>

<style scoped>
</style>
